<template>
  <div class="mt-5">
    <vs-table :data="devices">
            <template slot="thead">
                <vs-th sort-key="serial_number">Serial</vs-th>
                <vs-th sort-key="ownership">OwnerShip</vs-th>
                <vs-th sort-key="Model">Model</vs-th>
                <vs-th sort-key="Model">Device Name</vs-th>
                <vs-th sort-key="Model">Firmware version</vs-th>
                <vs-th sort-key="Model">Status</vs-th>
                <vs-th sort-key="configure">Configuration</vs-th>
            </template>

            <template slot-scope="">
                <vs-tr :key="device.serial_number" v-for="device in devices">
                    <vs-td :data="device.serial_number">
                        {{device.serial_number}}
                    </vs-td>
                    <vs-td :data="device.ownership">
                        {{device.ownership}}
                    </vs-td>
                    <vs-td :data="device.model">
                        {{device.model}}
                    </vs-td>
                    <vs-td :data="device.ownership">
                        {{device.device_name}}
                    </vs-td>
                    <vs-td :data="device.firmware_version">
                        {{device.firmware_version}}
                    </vs-td>
                    <vs-td :data="device.status">
                        {{device.status}}
                    </vs-td>
                    <vs-td>
                         <vs-button :disabled="device.status == 'disconnected'" color="primary" v-on:click="selectedDevice(device)" to="/hardware-configuration" type="filled">Configure</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
    </vs-table>
  </div>


</template>
<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { sendRequest } from "../utils/requestHelpers"

export default {
    data() {
        return {
            devices: [],
        }
    },
    methods: {
        DeviceStatusCallback(deviceOwner, deviceConfiguration){
            return (response) => {
                var device_data = {
                   'serial_number': deviceOwner.serial_number,
                   'device_name': deviceConfiguration.data.device_name,
                   'status': response.data[0].event_type,
                   'ownership': deviceOwner.owner_account,
                   'model': deviceOwner.device_model,
                   'firmware_version': deviceConfiguration.data.firmware_version,
               }
               this.devices.push(device_data);
            }
        },
        configurationSuccessCallback(device){
            return (response) => { 
                sendRequest('get', 'devices/' + device.serial_number + '/status/?limit=1', null, this.DeviceStatusCallback(device, response), null, this);
            }
        },
        getdevices() {
            var successCallback = (response) => {
                response.data.forEach(device => {
                    {
                        sendRequest('get', 'devices/' + device.serial_number + '/configurations/', null, this.configurationSuccessCallback(device), null, this);
                    }
                });
            };
            sendRequest("get", "devices/" , null, successCallback, null, this);
        },
        selectedDevice(device) {
            this.$store.commit('SAVE_SELECTED_DEVICE', device);
        }
    },
    created(){
        this.getdevices();
    }
}
</script>
